import React, { useContext, useState } from "react";
import Chip from "../../common/Chip";

import { ReactComponent as ArrowRightSvg } from "../../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowRightDisabledSvg } from "../../../assets/icons/arrow-right-disabled.svg";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/icons/arrow-left.svg";
import OnboardContext from "../context";
import { Form, Formik } from "formik";
import Button from "../../common/Button";
import { langComponent } from "../../../constants";
import AppContext from "../../../AppContext";

const Spaces = () => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.onboard);
  const TranslationCommon = getLang(langComponent.common);
  const TranslationSpaceType = getLang(langComponent.spaceType);
  const { designSpaces, goBack, goForward, information, addInformation } =
    useContext(OnboardContext);
  const [works, setWorks] = useState(information.interestSpaces || []);

  const handleOptionClick = (id, selected) => {
    // * Add to list
    if (selected) {
      const _works = works.concat([id]);
      setWorks(_works);
      return;
    }

    // * Remove from selection
    if (!selected) {
      const _works = works.filter((w) => w !== id);
      setWorks(_works);
    }
  };

  const handleSkip = () => {
    addInformation({ interestSpaces: undefined });
    goForward();
  };

  const handleSubmit = () => {
    if (!works || works.length === 0) return;
    addInformation({ interestSpaces: works });
    goForward();
  };

  return (
    <div className="onboard-interests">
      <h1 className="onboard__header">
        {Translation("What type of spaces are you interested in?")}
      </h1>
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        <Form className="onboard__form onboard__form-interests">
          <div className="onboard-interests__options">
            {designSpaces.map(({ _id, name }, index) => {
              return (
                <Chip
                  id={_id}
                  label={TranslationSpaceType(name)}
                  onClick={handleOptionClick}
                  key={`interest-key-${_id}`}
                  selected={works.find((f) => f === _id) !== undefined}
                />
              );
            })}
          </div>
          <div className="onboard__form-cta">
            <Button
              label={TranslationCommon("Return")}
              leadingIcon={<ArrowLeftSvg />}
              onClick={goBack}
              variant="secondary"
            />
            <div className="onboard__form-cta__divider" />
            <Button
              label={TranslationCommon("Skip")}
              variant="tertiary"
              onClick={handleSkip}
            />
            <Button
              type="submit"
              label={TranslationCommon("Continue")}
              trailingIcon={
                works.length > 0 ? <ArrowRightSvg /> : <ArrowRightDisabledSvg />
              }
              disabled={works.length === 0}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
};

Spaces.propTypes = {};

export default Spaces;
